export default __webpack_public_path__ + "66294e3e64743e7d398b8509a01550c4.jpg";